import { Box } from "@mui/material";
import { Position } from "reactflow";
import { INodeData } from "../../index";
import CustomHandler from "../../Helpers/CustomHandler";


export default function NodeAcaoExterna({ data }: INodeData) {

    return (
        <Box position="relative">
            <CustomHandler type="target" id="target-left" position={Position.Left} />
            <Box
                bgcolor="#17a2b8"
                border={`2px solid rgba(0,0,0, ${data.isClicked ? "0.7" : "0.2"})`}
                height={60}
                width={200}
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius={2}
            >
                <Box sx={{ textAlign: 'center', fontSize: 10, color: "white" }}>{data.titulo}</Box>
            </Box>
            <CustomHandler type="source" id="source-right" position={Position.Right} />
        </Box>
    )

}